var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header-wrapper',[(_vm.schema)?_c('AMisRendererDiv',{attrs:{"schema":_vm.schema}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }